import { customSleep } from "./../common/index";
import { documentReady, setRem } from "@/preset/rem";
import {
  getAppStatusBarHeight,
  getAppBottomHeight
} from "../native/interaction";

export const HEADER_HEIGHT = 48;
export const getHeaderHeightByPixel = (): number =>
  window.SCREEN_SCALE * HEADER_HEIGHT;

// 设置header height css变量
export const setHeaderHeightVariable = async (ignoreStatusBar = false) => {
  // console.log("ignoreStatusBar", ignoreStatusBar);
  await documentReady();
  setRem();
  await customSleep(50);
  const statusBarHeight = ignoreStatusBar
    ? 0
    : await getAppStatusBarHeight(ignoreStatusBar);
  window.__APP_HEADER_REAL_HEIGHT__ =
    statusBarHeight + getHeaderHeightByPixel();
  // console.log(statusBarHeight, getHeaderHeightByPixel(), window.SCREEN_SCALE);
  document.documentElement.style.setProperty(
    "--header-height--",
    statusBarHeight + getHeaderHeightByPixel() + "px"
  );
  document.documentElement.style.setProperty(
    "--status-bar-height--",
    statusBarHeight + "px"
  );
};

export const setBottomHeightVariable = async () => {
  document.documentElement.style.setProperty(
    "--bottom-height--",
    (await getAppBottomHeight()) + "px"
  );
};

// header高度------全屏webview可使用
export const getHeaderHeightByApp = async (): Promise<number> => {
  const statusBarHeight: number = await getAppStatusBarHeight();
  return statusBarHeight + getHeaderHeightByPixel();
};
